import { Fragment } from "react";
import { NavLink } from "react-router-dom";
import "./Logistics.css";
import PhoneIcon from "@mui/icons-material/Phone";
import logisticsmain from "../../assets/images/services/logistics/logisticsmain.jpg";
import logistictop from "../../assets/images/services/logistics/logistictop.jpg";
import logisticbottom from "../../assets/images/services/logistics/logisticbottom.jpg";
import supplychain from "../../assets/images/services/logistics/supplychain.png";
import realtimemanagement from "../../assets/images/services/logistics/realtimemanagement.png";
import seamlessintegration from "../../assets/images/services/logistics/seamlessintegration.png";

const Logistics = () => {
  return (
    <Fragment>
      <section className="logistics-style">
        <div className="container">
          <div className="logistics-banner-content">
            <div
              className="subtitle-gradient"
              data-aos="fade-down"
              data-aos-delay="200"
              data-aos-duration="1200"
            >
              Supplychain & Logistics
            </div>
            <h1
              data-aos="fade-down"
              data-aos-delay="400"
              data-aos-duration="1200"
            >
              Blockchain development for Supplychain & Logistics
            </h1>
            <p
              data-aos="fade-down"
              data-aos-delay="600"
              data-aos-duration="1200"
            >
              Examining how blockchain transforms supply chain and logistics
              operations through transparency, traceability, and automation.
            </p>
            <div
              className="consultation-btn"
              data-aos="fade-down"
              data-aos-delay="800"
              data-aos-duration="1200"
            >
              <NavLink to="/contact" target="-black">
                <span>
                  Request A Consultation <PhoneIcon />
                </span>
              </NavLink>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4">
              <div className="capsule-breakout">
                <div className="logistics-shape">
                  <img src={logisticsmain} className="main-img" />
                  <img src={logistictop} className="floating-img top" />
                  <img src={logisticbottom} className="floating-img bottom" />
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-12">
              <div className="logistics-future-content">
                <h1
                  data-aos="fade-down"
                  data-aos-delay="200"
                  data-aos-duration="1200"
                >
                  Future of Supplychain & Logistics with blockchain integration
                </h1>
                <p
                  data-aos="fade-down"
                  data-aos-delay="400"
                  data-aos-duration="1200"
                >
                  Blockchain will revolutionize logistics. It has already
                  started the industry shift from the traditional approach of
                  manual processes and third-party trust-based systems to a more
                  logical blockchain solution for logistics. The current
                  logistics system is plagued by many issues that can be easily
                  overcome with blockchain solutions. With the proliferating
                  rate of globalization, the intricate logistics management
                  systems designed with geographical limitations are bound to
                  collapse. Blockchain truly gives access to potential expansion
                  without worrying about the place of origin of the product.
                  Sustainability is something that businesses are fortunately
                  looking into, doing their part to avoid exhausting world
                  resources. Blockchain can make it easier for you to introduce
                  systems that are not just environmentally sustainable, but
                  also more financially feasible. Apart from these issues,
                  blockchain will directly affect the roots by updating the
                  system in a way that will directly affect the product journey
                  and indirectly, many other issues in the future like- customer
                  service and quality, third-party networks, management and
                  organizational approach, quick assessment and response, a more
                  defined role and a more operative relationship between all
                  parties involved. All in all, blockchain implementation in
                  logistics will merge information and material handling systems
                  with better data synchronization and truly optimize logistic
                  systems. It will bridge functions and organizations.
                </p>
              </div>
            </div>
          </div>

          <div className="logistics-keyfeatures">
            <div className="text-center">
              <h1
                data-aos="fade-down"
                data-aos-delay="400"
                data-aos-duration="1200"
              >
                Key Features of the Supplychain & Logistics <br></br> Software
                We Build
              </h1>
            </div>
            <div className="row d-flex justify-content-center">
              <div
                className="col-lg-4 col-md-6"
                data-aos="zoom-in-up"
                data-aos-delay="200"
                data-aos-duration="1200"
              >
                <div className="logistics-icon">
                  <img src={supplychain} alt="img-not-found" />
                </div>
                <h6>Enhanced Supply Chain Visibility</h6>
                <p>
                  Our logistics software solutions are tailored to your business
                  needs, providing real-time insights into diverse aspects of
                  your supply chain, from raw material procurement to finished
                  goods delivery. This facilitates seamless tracking and
                  monitoring of shipments, inventory management, and proactive
                  identification of potential disruptions.
                </p>
              </div>
              <div
                className="col-lg-4 col-md-6"
                data-aos="zoom-in-up"
                data-aos-delay="400"
                data-aos-duration="1200"
              >
                <div className="logistics-icon">
                  <img src={realtimemanagement} alt="img-not-found" />
                </div>
                <h6>Real-time Management</h6>
                <p>
                  Our software solutions offer unmatched real-time tracking and
                  user-friendly dashboards within a unified interface, allowing
                  you to dynamically adjust routes, allocate resources
                  efficiently, and monitor crucial KPIs. This enables timely
                  responses and well-informed decisions to optimize overall
                  business performance.
                </p>
              </div>
              <div
                className="col-lg-4 col-md-6"
                data-aos="zoom-in-up"
                data-aos-delay="600"
                data-aos-duration="1200"
              >
                <div className="logistics-icon">
                  <img src={seamlessintegration} alt="img-not-found" />
                </div>
                <h6>Seamless Integration</h6>
                <p>
                  We develop logistics software solutions that are designed to
                  integrate with your current workflows, ensuring effortless
                  connectivity seamlessly. Real-time synchronization across
                  platforms eliminates manual tasks, boosting operational
                  efficiency and accuracy.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="logistics-usecase">
          <div className="container">
            <div className="text-center">
              <h1
                data-aos="fade-down"
                data-aos-delay="300"
                data-aos-duration="1200"
              >
                Use Cases for Blockchain in Supplychain & Logistics
              </h1>
            </div>
            <div className="row">
              <div
                className="col-lg-3 col-md-6"
                data-aos="fade-left"
                data-aos-delay="200"
                data-aos-duration="1200"
              >
                <h6>Environmental and Ethical Sustainability</h6>
                <p>
                  Blockchain technology can help companies ensure that their
                  products are ethically sourced. By tracking products from the
                  point of origin, businesses can identify and flag any
                  potential ethical issues such as child or slave labour, fair
                  wages or safe working environments in the supply chain.
                </p>
              </div>
              <div
                className="col-lg-3 col-md-6"
                data-aos="fade-left"
                data-aos-delay="400"
                data-aos-duration="1200"
              >
                <h6>Quality Assurance</h6>
                <p>
                  Blockchain technology can be used to ensure that products meet
                  certain quality standards throughout the supply chain. By
                  recording data on the blockchain at each stage of production,
                  companies can track and verify compliance with specific
                  requirements.
                </p>
              </div>
              <div
                className="col-lg-3 col-md-6"
                data-aos="fade-left"
                data-aos-delay="600"
                data-aos-duration="1200"
              >
                <h6>Counterfeit Prevention</h6>
                <p>
                  Brand and product piracy through counterfeit products is a
                  significant problem in many industries, especially luxury
                  goods and pharmaceuticals. Blockchain technology can help
                  prevent counterfeiting by creating a tamper-proof record of
                  product ownership and authenticity.
                </p>
              </div>
              <div
                className="col-lg-3 col-md-6"
                data-aos="fade-left"
                data-aos-delay="800"
                data-aos-duration="1200"
              >
                <h6>Streamlining Payment Processing</h6>
                <p>
                  Blockchain technology can also be used to streamline payment
                  processing in supply chains. By using smart contracts,
                  payments can be automated based on predefined conditions such
                  as delivery confirmation or quality inspection.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Logistics;
